import { getProfile } from "@/actions/auth";
import ProfileLayout from "@/components/landing/account/ProfileLayout";
import Profile from '@/components/landing/account/profile';
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProfileDashboardComponent from "@/components/landing/account/dashboard";

const ProfileDashboard = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getProfile());
    }, []);
    return (
        <>
            <ProfileLayout>
                <ProfileDashboardComponent />
            </ProfileLayout>
        </>
    )
}

export default ProfileDashboard;